import makeAjaxRequest from 'helpers/makeAjaxRequest';
import { attributeTreeDropDownUrl } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const fetchAttributeTreeDropDown = (ownerType, attributeClass, callback) => async () => {
  makeAjaxRequest.fetchWithAuth(attributeTreeDropDownUrl(ownerType, attributeClass)).then(res => callback(res));
};
